/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useRef } from 'react';
import CmvBidBarrel from '@cbsi-ctd/cmv_bidbarrel';
import Store from '~/store/undux';
import { verifyAnalytics } from '~/utils/utils';

/**
 * Bid Barrel
 * @category Functional Component
 * @summary Includes and configures the bid barrel lib.
 * @prop {obj} data - Data coming down from the parent page.
 * @prop {obj} mapToAdUnits - The ad map.
 * @return {Node} React node intilizing bid barrel.
 */

const BidBarrelReact = (props) => {
  const store = Store.useStore();
  const { data = {}, mapToAdUnits } = props;
  const refBidBarrel = useRef(null);
  const hasInit = useRef(false);
  const setStickyBanner = store.set('stickyBanner');
  const setMenuOffset = store.set('mainMenuOffset');

  useEffect(() => {
    const toggleSticky = (stickyClass, offset) => {
      if(store.get('stickyBanner') !== stickyClass) {
        setStickyBanner(stickyClass);
        setMenuOffset(offset);
      }
    };

    const create = async () => {
      const isAnalyticsVerified = await verifyAnalytics(100, 10);

      // Ensure we have analytics
      if(isAnalyticsVerified) {
        const category = data && data.field_category
          ? data.field_category.name
          : '';

        const config = {
          debug: true,
          mobileBreak: 740,
          adSelector: '[data-ad-ref]',
          scriptUrl: process.env.NEXT_PUBLIC_BID_BARREL_URL,
          networkId: '8264',
          mobileAdUnitSizePrefix: 'maw-thedrewbarrymoreshow',
          adUnitSizePrefix: 'aw-thedrewbarrymoreshow',
          mapToAdUnits,
          page_targeting: {
            ad_unit_path_suffix: window.utag_data.siteSection,
            nid: data.nid || '',
            keywords: data.field_tags
              ? data.field_tags.map((item) => item.name).join(',')
              : '',
            category,
            categories: category, // @NOTE: Override this if you have multiple categories
            ad_page_type: window.utag_data.pageType,
            env: process.env.NEXT_PUBLIC_ENV,
            vguid: window.utag.data.pageViewGuid,
            ftag: window.utag_data.campaign
          },
          toggleSticky
        }

        if(!refBidBarrel.current) {
          refBidBarrel.current = new CmvBidBarrel(config);
          refBidBarrel.current.init();
        }

        refBidBarrel.current.auction();
        hasInit.current = true;
      }
    };

    // Start BidBarrel
    create();

    return async () => {
      // @NOTE: Due to persistence sticky banner cleanup is handled in header.js in routeChangeComplete.
      // Cleanup
      if(refBidBarrel.current) {
        refBidBarrel.current.resetAllTargeting();
        refBidBarrel.current.clearSlots();
        hasInit.current = false;
      }
    };
  }, []);

  return (
    <></>
  );
}

export default memo(BidBarrelReact);
